import { SET_WORKOUT_TEMPLATES, SET_WORKOUT_TEMPLATE_BY_ID, RESET_WORKOUT_TEMPLATE_BY_ID } from './workoutTemplateTypes';

const initialState = {
	list: [],
	currentTemplate: null,
	loading: false,
};

export const workoutTemplateReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_WORKOUT_TEMPLATES:
			return { ...state, list: action.payload };
		case SET_WORKOUT_TEMPLATE_BY_ID:
			return { ...state, currentTemplate: action.payload };
		case RESET_WORKOUT_TEMPLATE_BY_ID:
			return { ...state, currentTemplate: null };
		default:
			return state;
	}
};
